import React, { useState, useEffect, useCallback } from "react";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../components/Table";
import {
  getAllFreezeData,
  freezedateAction,
  freezedateDeleteAction,
} from "../../store/actions/monthEnd";

const FreezeDatesDev = () => {
  const dispatch = useDispatch();
  const [freezeStartDate, setFreezeStartDate] = useState("");
  const [freezeStartTime, setFreezeStartTime] = useState("00:00");
  const [freezeEndDate, setFreezeEndDate] = useState("");
  const [freezeEndTime, setFreezeEndTime] = useState("11:59");
  const [updateFreezeStartDateValue, setUpdateFreezeStartDateValue] = useState("");
  const [updateFreezeStartTimeValue, setUpdateFreezeStartTimeValue] = useState("00:00");
  const [updateFreezeEndDateValue, setUpdateFreezeEndDateValue] = useState("");
  const [updateFreezeEndTimeValue, setUpdateFreezeEndTimeValue] = useState("11:59");
  const [updateLoginDateValue, setUpdateLoginDateValue] = useState("");
  const [updateLoginTimeValue, setUpdateLoginTimeValue] = useState("");
  const [loginDate, setLoginDate] = useState("");
  const [loginTime, setLoginTime] = useState("");
  const [selection, setSelection] = useState("Login");
  const [minDate, setMinDate] = useState("");
  const [errors, setErrors] = useState({});
  const [isEndDateTimeEnabled, setIsEndDateTimeEnabled] = useState(false);
  const [updateisEndDateTimeEnabled, setupdateIsEndDateTimeEnabled] = useState(false);
  const [showEditModal, setshowEditModal] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [data, setData] = useState([]);
  const [freezeStartDateTimevalidate, setFreezeStartDateTimevalidate] = useState("");
  const [curreFreezingTimeUpdate, setCurreFreezingTimeUpdate] = useState("");

  useEffect(() => {
    // Fetch the API data
    dispatch(
      getAllFreezeData((response) => {
        // Set the data in the local state
        setData(
          response.body.map((item) => ({
            id: item.id,
            createdBy: item.createdBy,
            freezeType: item.freezeType,
            freezeStartDate: item.freezeStartDate,
            freezeEndDate: item.freezeEndDate,
            dateValue: item.freezeType,
          })),
        );
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    // Set the minimum date to today's date
    const today = new Date().toISOString().split("T")[0];
    setMinDate(today);
  }, []);

  useEffect(() => {
    // Set the minimum date for freezeEndDate based on freezeStartDate
    if (freezeStartDate) {
      document
        .getElementById("freezeEndDate")
        .setAttribute("min", freezeStartDate);
    }
  }, [freezeStartDate]);

  useEffect(() => {
    // Enable freezeEndDate and freezeEndTime if both freezeStartDate and freezeStartTime are set
    if (freezeStartDate) {
      setIsEndDateTimeEnabled(true);
    } else {
      setIsEndDateTimeEnabled(false);
    }
  }, [freezeStartDate, freezeStartTime]);

  useEffect(() => {
    // Enable freezeEndDate and freezeEndTime if both freezeStartDate and freezeStartTime are set
    if (updateFreezeStartDateValue) {
      setupdateIsEndDateTimeEnabled(true);
    } else {
      setupdateIsEndDateTimeEnabled(false);
    }
  }, [updateFreezeStartDateValue]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (freezeStartDate || freezeStartTime) {
      setLoginDate(freezeStartDate);
    }
  }, [freezeStartDate]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (freezeStartTime) {
      setLoginTime(freezeStartTime);
    }
  }, [freezeStartTime]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (updateFreezeStartDateValue) {
      setUpdateLoginDateValue(updateFreezeStartDateValue);
    }
  }, [updateFreezeStartDateValue]);

  useEffect(() => {
    // Auto-fill loginDate with freezeStartDate when freezeStartDate changes
    if (updateFreezeStartTimeValue) {
      setUpdateLoginTimeValue(updateFreezeStartTimeValue);
    }
  }, [updateFreezeStartTimeValue]);

  const formatDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  // Function to reformat date to YYYY-MM-DD format
  const reformatDateToInputFormat = (dateString) => {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };
  const parseDateTime = (date, time) => {
    const [day, month, year] = date.split('-').map(Number);
    const [hours, minutes] = time.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes);
  }

  const handleSave = async () => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let validationErrors = {};

    // Check if required fields are empty
    if (!freezeStartDate)
      validationErrors.freezeStartDate = "Freeze Start Date is required";
    // if (!freezeStartTime)
    //   validationErrors.freezeStartTime = "Freeze Start Time is required";
    if (!freezeEndDate)
      validationErrors.freezeEndDate = "Freeze End Date is required";
    // if (!freezeEndTime)
    //   validationErrors.freezeEndTime = "Freeze End Time is required";
    if (!loginDate) validationErrors.loginDate = "Date is required";
    // if (!loginTime) validationErrors.loginTime = "Time is required";

    // Set errors and return if there are any
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    const currentDateTime = new Date();
    const freezeStartDateTime = new Date(`${freezeStartDate}T${'00:00'}`,);
    const freezeEndDateTime = new Date(`${freezeEndDate}T${'11:59'}`,);

    // Check if freezeStartDateTime and freezeEndDateTime are not greater than currentDateTime
    if (
      freezeStartDateTime < currentDateTime ||
      freezeEndDateTime < currentDateTime
    ) {
      validationErrors.global = "Freeze Start DateTime and Freeze End DateTime cannot be in the past.";
      setErrors(validationErrors);
      return;
    }

    const diffInTime = freezeEndDateTime - freezeStartDateTime;
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    if (diffInDays > 15) {
      validationErrors.global = "The difference between Freeze Start and End dates cannot be greater than 15 days.";
      setErrors(validationErrors);
      setLoginDate(freezeStartDate);
      setLoginTime(freezeStartTime);
      setFreezeEndDate("");
      setFreezeEndTime("");
      return;
    }
    
    const formattedFreezeStartDateTime = `${formatDate(freezeStartDate)} ${'00:00'}`;
    const formattedFreezeEndDateTime = `${formatDate(freezeEndDate)} ${'11:59'}`;
    const formattedLoginDate = `${formatDate(loginDate)} ${loginTime}`;
    // Validate loginDateTime is between freezeStartDateTime and freezeEndDateTime
    const parFreezeStartDateTime = parseDateTime(formatDate(freezeStartDate), '00:00');
    const parformattedFreezeEndDateTime = parseDateTime(formatDate(freezeEndDate), '11:59');
    const parformattedLoginDate = parseDateTime(formatDate(loginDate), loginTime);

    if (parformattedLoginDate < parFreezeStartDateTime || parformattedLoginDate > parformattedFreezeEndDateTime) {
      validationErrors.global = "DateTime must be between Freeze Start DateTime and Freeze End DateTime.";
      setErrors(validationErrors);
      return;
    }
    const formData = {
      createdBy: userDetails.user.code,
      //freezeType: selection.toUpperCase(),
      freezeStartDate: formattedFreezeStartDateTime,
      freezeEndDate: formattedFreezeEndDateTime,
      dateValue: formattedFreezeStartDateTime,
    };
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch(freezedateAction(formData, (res) => {
        if (res.data.body) {
          
      // Clear all input fields
      setFreezeStartDate("");
      setFreezeStartTime("");
      setFreezeEndDate("");
      setFreezeEndTime("");
      setLoginDate("");
      setLoginTime("");
          // Dispatch the getAllFreezeData action
          dispatch(
            getAllFreezeData((response) => {
              // Set the data in the local state
              setData(
                response.body.map((item) => ({
                  id: item.id,
                  createdBy: item.createdBy,
                  //freezeType: item.freezeType,
                  freezeStartDate: item.freezeStartDate,
                  freezeEndDate: item.freezeEndDate,
                  dateValue: item.freezeStartDate,
                })),
              );
            }),
          );
        }
      }))

    } catch (error) {
      console.error("Error during saving:", error);
      // Handle any errors that might occur during the dispatch
    }
  };

  useEffect(() => {
    if (modalData) {
      // Reformat and set freezeStartDate
      if (modalData.freezeStartDate) {
        const [startDate, startTime] = modalData.freezeStartDate.split(" ");
        setUpdateFreezeStartDateValue(reformatDateToInputFormat(startDate));
        // setUpdateFreezeStartTimeValue(startTime);

        const checkCurrentDate = new Date();
        const [day, month, yearTime] = modalData.freezeStartDate.split('-');
        const [monthYear, time] = yearTime.split(' ');
        const [year] = monthYear.split(' ');
        const formattedDateString = `${year}-${month}-${day}T${time}:00`; // Convert to ISO 8601 format
        const freezeStartDateTimevalidate = new Date(formattedDateString);
        setFreezeStartDateTimevalidate(freezeStartDateTimevalidate)
        // Check if freezeStartDateTime and freezeEndDateTime are not greater than currentDateTime
        const setFreezingTimeUpdate = checkCurrentDate > freezeStartDateTimevalidate ? true : false
        setCurreFreezingTimeUpdate(setFreezingTimeUpdate)
      } else {
        console.error("freezeStartDate is undefined or null");
      }

      // Reformat and set freezeEndDate
      if (modalData.freezeEndDate) {
        const [endDate, endTime] = modalData.freezeEndDate.split(" ");
        setUpdateFreezeEndDateValue(reformatDateToInputFormat(endDate));
        // setUpdateFreezeEndTimeValue(endTime);
      } else {
        console.error("freezeEndDate is undefined or null");
      }

      // Reformat and set dateValue
      if (modalData.dateValue) {
        setUpdateLoginDateValue(reformatDateToInputFormat(modalData.dateValue));
      } else {
        console.error("dateValue is undefined or null");
      }
    }
  }, [modalData]);

  const updatefreezeData = async () => {
    let validationErrors = {};

    // Check if required fields are empty
    if (!updateFreezeStartDateValue)
      validationErrors.updateFreezeStartDateValue =
        "Freeze Start Date is required";
    // if (!updateFreezeStartTimeValue)
    //   validationErrors.updateFreezeStartTimeValue =
    //     "Freeze Start Time is required";
    if (!updateFreezeEndDateValue)
      validationErrors.updateFreezeEndDateValue = "Freeze End Date is required";
    // if (!updateFreezeEndTimeValue)
    //   validationErrors.updateFreezeEndTimeValue = "Freeze End Time is required";
    if (!updateLoginDateValue)
      validationErrors.updateLoginDateValue = "Date is required";
    // if (!updateLoginTimeValue)
    //   validationErrors.updateLoginTimeValue = "Time is required";

    // Set errors and return if there are any
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    const updatecurrentDateTime = new Date();
    const updatefreezeStartDateTime = new Date(
      `${updateFreezeStartDateValue}T${'00:00'}`,
    );
    const updatefreezeEndDateTime = new Date(
      `${updateFreezeEndDateValue}T${'11:59'}`,
    );
    if (curreFreezingTimeUpdate) {
        // If CurreFreezingTimeUpdate is true, only check the first condition.
        if (updatefreezeEndDateTime < updatecurrentDateTime) {
            validationErrors.global = "Freeze End DateTime cannot be in the past.";
            setErrors(validationErrors);
            return;
        }
    } else {
        // If CurreFreezingTimeUpdate is false, check both conditions.
        if ((updatefreezeStartDateTime < updatecurrentDateTime) || (updatefreezeEndDateTime < updatecurrentDateTime)) {
            validationErrors.global = "Freeze Start DateTime and Freeze End DateTime cannot be in the past.";
            setErrors(validationErrors);
            return;
        }
    }

    const updatediffInTime =
      updatefreezeEndDateTime - updatefreezeStartDateTime;
    const updatediffInDays = updatediffInTime / (1000 * 3600 * 24);

    if (updatediffInDays > 15) {
      validationErrors.global = "The difference between Freeze Start and End dates cannot be greater than 15 days.";
      setErrors(validationErrors);
      setUpdateLoginDateValue(updateFreezeStartDateValue);
      setUpdateLoginTimeValue(updateFreezeStartTimeValue);
      setUpdateFreezeEndDateValue("");
      setUpdateFreezeEndTimeValue("");
      return;
    }
    
   
    const updateformattedFreezeStartDateTime = `${formatDate(updateFreezeStartDateValue)} ${'00:00'}`;
    const updateformattedFreezeEndDateTime = `${formatDate(updateFreezeEndDateValue)} ${'11:59'}`;
    const updateformattedLoginDate = `${formatDate(updateLoginDateValue)} ${updateLoginTimeValue}`;
    
    // Validate loginDateTime is between freezeStartDateTime and freezeEndDateTime
    
    
    const updateformattedFreezeStartDateTimeVal = parseDateTime(formatDate(updateFreezeStartDateValue), '00:00');
    const updateformattedFreezeEndDateTimeVal = parseDateTime(formatDate(updateFreezeEndDateValue), '11:59');
    const updateformattedLoginDateVal = parseDateTime(formatDate(updateLoginDateValue), updateLoginTimeValue);

    if (updateformattedLoginDateVal < updateformattedFreezeStartDateTimeVal || updateformattedLoginDateVal > updateformattedFreezeEndDateTimeVal) {
      validationErrors.global = "Login DateTime must be between Freeze Start DateTime and Freeze End DateTime.";
      setErrors(validationErrors);
      return;
    }
    const formData = {
      id: modalData.id,
      freezeStartDate: updateformattedFreezeStartDateTime,
      freezeEndDate: updateformattedFreezeEndDateTime,
      dateValue: updateformattedFreezeStartDateTime,
    };
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch(freezedateAction(formData, (res) => {
        if (res.data.body) {
          setshowEditModal(false);
           // Clear all input fields
        setUpdateFreezeStartDateValue("");
        setUpdateFreezeStartTimeValue("");
        setUpdateFreezeEndDateValue("");
        setUpdateFreezeEndTimeValue("");
        setUpdateLoginDateValue("");
        setUpdateLoginTimeValue("");
          // Dispatch the getAllFreezeData action
          dispatch(
            getAllFreezeData((response) => {
              // Set the data in the local state
              setData(
                response.body.map((item) => ({
                  id: item.id,
                  createdBy: item.createdBy,
                  //freezeType: item.freezeType,
                  freezeStartDate: item.freezeStartDate,
                  freezeEndDate: item.freezeEndDate,
                  dateValue: item.freezeStartDate,
                })),
              );
            }),
          );
        }
      }))
     
     
    } catch (error) {
      console.error("Error during saving:", error);
      // Handle any errors that might occur during the dispatch
    }
  };

  const deleteData = async (modalData) => {
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch(freezedateDeleteAction(modalData, (res) => {
         setshowDeleteModal(false);
        if (res.data.body === true) {
          // Dispatch the getAllFreezeData action
          dispatch(
            getAllFreezeData((response) => {
              // Set the data in the local state
              setData(
                response.body.map((item) => ({
                  id: item.id,
                  createdBy: item.createdBy,
                  //freezeType: item.freezeType,
                  freezeStartDate: item.freezeStartDate,
                  freezeEndDate: item.freezeEndDate,
                  dateValue: item.freezeStartDate,
                })),
              );
            }),
          );
        }
      }))
    } catch (error) {
      console.error("Error during saving:", error);
      // Handle any errors that might occur during the dispatch
    }
  };

  return (
    <>
      <div className="month-end-config-page__panel">
        <form className="month-end-config-page__form createForm">
          <div className="row dNone">
            <div className="mb-3 col-6">
              <label htmlFor="selection" className="month-end-config-page__label">
                Select Option
              </label>
              <div className="custom-select-container">
                <select
                  id="selection"
                  className="month-end-config-page__select"
                  value={selection}
                  onChange={(e) => setSelection(e.target.value)}
                >
                  <option value="Login">Login</option>
                  <option value="Issuance">Issuance</option>
                </select>
              </div>
            </div>
          </div>

          <div className="month-end-config-page__compact-grid">
            <div className="month-end-config-page__field">
              <label htmlFor="freezeStartDate" className="month-end-config-page__label">
                Freeze Start Date
              </label>
              <input
                type="date"
                id="freezeStartDate"
                className="month-end-config-page__input month-end-config-page__input--date"
                value={freezeStartDate}
                onChange={(e) => {
                  setFreezeStartDate(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    freezeStartDate: "",
                  }));
                }}
                min={minDate}
                max={freezeEndDate}
              />
              {errors.freezeStartDate && (
                <div className="text-danger">{errors.freezeStartDate}</div>
              )}
            </div>

            <div className="month-end-config-page__field">
              <label htmlFor="freezeEndDate" className="month-end-config-page__label">
                Freeze End Date
              </label>
              <input
                type="date"
                id="freezeEndDate"
                className="month-end-config-page__input month-end-config-page__input--date"
                value={freezeEndDate}
                onChange={(e) => {
                  setFreezeEndDate(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    freezeEndDate: "",
                  }));
                }}
                min={freezeStartDate || minDate}
                disabled={!isEndDateTimeEnabled}
              />
              {errors.freezeEndDate && (
                <div className="text-danger">{errors.freezeEndDate}</div>
              )}
            </div>
          </div>

          <div className="row dNone">
            <div className="mb-3 col-8 col-lg-4">
              <label htmlFor="loginDate" className="month-end-config-page__label">
                {selection === "Login"
                  ? "Login Start Date"
                  : "Issuance Start Date"}
              </label>
              <input
                type="date"
                id="loginDate"
                className="month-end-config-page__input month-end-config-page__input--date"
                value={loginDate}
                onChange={(e) => {
                  setLoginDate(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    loginDate: "",
                  }));
                }}
                min={freezeStartDate || minDate}
                max={freezeEndDate}
              />
              {errors.loginDate && (
                <div className="text-danger">{errors.loginDate}</div>
              )}
            </div>

            <div className="mb-3 col-4 col-lg-2">
              <input
                type="time"
                id="loginTime"
                className="month-end-config-page__input month-end-config-page__input--date"
                value={loginTime}
                onChange={(e) => {
                  setLoginTime(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    loginTime: "",
                  }));
                }}
              />
              {errors.loginTime && (
                <div className="text-danger">{errors.loginTime}</div>
              )}
            </div>
          </div>

          {errors.global && (
            <div className="month-end-config-page__error" role="alert">
              {errors.global}
            </div>
          )}

          <div className="month-end-config-page__actions">
            <button
              type="button"
              className="month-end-config-page__btn month-end-config-page__btn--primary"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </form>
      </div>

      <div className="month-end-config-page__note">
        <div className="month-end-config-page__note-title">Rules</div>
        <div className="month-end-config-page__note-points">
          <p>1. Only future freezes can be created.</p>
          <p>2. Overlapping freeze dates are not allowed.</p>
          <p>3. Current freeze dates cannot be edited or deleted.</p>
        </div>
      </div>

      {data?.length > 0 && (
        <div className="proposal-dashboard__table-section month-end-config-page__table-section">
            <DataTable
              cellHeaders={[
                "Id",
                "Created By",
                //"Freeze Type",
                "Freeze Start Date",
                "Freeze End Date",
                "Date Value",
                "",
              ]}
              data={data}
              keys={[
                "id",
                "createdBy",
                //"freezeType",
                "freezeStartDate",
                "freezeEndDate",
                "dateValue",
                "FreezecustomButtons",
              ]}
              fileName="Freeze Data"
              addSerialNo={false}
              onCustomButtonClick={(item) => {
                setModalData(item);
                setshowEditModal(true);
              }}
              onCustomDeletButtonClick={(item) => {
                setModalData(item);
                setshowDeleteModal(true);
              }}
              convertValueToString={true}
              showExcelDownload={true}
              PerPageApiData={false}
              paginationItems={data}
              alwaysShown={false}
            />
        </div>
      )}
      {showEditModal && Object.values(modalData).length > 0 && (
        <MobilePopUp onClose={() => setshowEditModal(false)}>
          <div className="month-end-config-page__modal-form">
            <div className="month-end-config-page__compact-grid month-end-config-page__compact-grid--modal">
              <div className="month-end-config-page__field">
                <label
                  htmlFor="updateFreezeStartDate"
                  className="month-end-config-page__label"
                >
                  Freeze Start Date
                </label>
                <input
                  type="date"
                  id="updateFreezeStartDate"
                  className="month-end-config-page__input month-end-config-page__input--date"
                  value={updateFreezeStartDateValue}
                  onChange={(e) => {
                    setUpdateFreezeStartDateValue(e.target.value);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      updateFreezeStartDateValue: "",
                    }));
                  }}
                  min={minDate}
                  max={updateFreezeEndDateValue}
                  disabled={curreFreezingTimeUpdate}
                />
                {errors.updateFreezeStartDateValue && (
                  <div className="text-danger">
                    {errors.updateFreezeStartDateValue}
                  </div>
                )}
              </div>

              <div className="month-end-config-page__field">
                <label
                  htmlFor="updateFreezeEndDate"
                  className="month-end-config-page__label"
                >
                  Freeze End Date
                </label>
                <input
                  type="date"
                  id="updateFreezeEndDate"
                  className="month-end-config-page__input month-end-config-page__input--date"
                  value={updateFreezeEndDateValue}
                  onChange={(e) => {
                    setUpdateFreezeEndDateValue(e.target.value);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      updateFreezeEndDateValue: "",
                    }));
                  }}
                  min={updateFreezeStartDateValue}
                  disabled={!updateisEndDateTimeEnabled}
                />
                {errors.updateFreezeEndDateValue && (
                  <div className="text-danger">
                    {errors.updateFreezeEndDateValue}
                  </div>
                )}
              </div>
            </div>

            <div className="row dNone">
              <div className="mb-3 col-8">
                <label htmlFor="loginDate" className="month-end-config-page__label">
                  {selection === "Login"
                    ? "Login Start Date"
                    : "Issuance Start Date"}
                </label>
                <input
                  type="date"
                  id="updateLoginDate"
                  className="month-end-config-page__input month-end-config-page__input--date"
                  value={updateLoginDateValue}
                  onChange={(e) => {
                    setUpdateLoginDateValue(e.target.value);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      updateLoginDateValue: "",
                    }));
                  }}
                  min={updateFreezeStartDateValue || minDate}
                  max={updateFreezeEndDateValue}
                />
                {errors.updateLoginDateValue && (
                  <div className="text-danger">
                    {errors.updateLoginDateValue}
                  </div>
                )}
              </div>
              <div className="mb-3 col-4">
                <input
                  type="time"
                  id="updateLoginTime"
                  className="month-end-config-page__input month-end-config-page__input--date"
                  value={updateLoginTimeValue}
                  onChange={(e) => {
                    setUpdateLoginTimeValue(e.target.value);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      updateLoginTimeValue: "",
                    }));
                  }}
                />
                {errors.updateLoginTimeValue && (
                  <div className="text-danger">
                    {errors.updateLoginTimeValue}
                  </div>
                )}
              </div>
            </div>

            {errors.global && (
              <div className="month-end-config-page__error" role="alert">
                {errors.global}
              </div>
            )}

            <div className="month-end-config-page__modal-actions">
              <button
                type="button"
                className="month-end-config-page__btn month-end-config-page__btn--primary"
                onClick={() => updatefreezeData()}
              >
                Update
              </button>
            </div>
          </div>
        </MobilePopUp>
      )}

      {showDeleteModal && Object.values(modalData).length && (
        <MobilePopUp
          onClose={() => {
            setshowDeleteModal(false);
          }}
        >
          <div className="month-end-config-page__delete-modal">
            <div className="month-end-config-page__delete-title">
              Are you sure?
            </div>
            <div className="month-end-config-page__delete-text">
              You won&apos;t be able to revert this!
            </div>
            <div className="month-end-config-page__delete-actions">
              <button
                type="button"
                className="month-end-config-page__btn month-end-config-page__btn--secondary"
                onClick={() => setshowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="month-end-config-page__btn month-end-config-page__btn--danger"
                onClick={() => deleteData(modalData)}
              >
                Yes, delete it!
              </button>
            </div>
          </div>
        </MobilePopUp>
      )}
    </>
  );
};

export default FreezeDatesDev;